export const contacts = {
  address: 'ул. Макатаева 117 (корпус «А», офис 7)',
  time: '08.00 - 21.00',
  phone: '+7 747 555-32-22',
  email: 'irisiris@apoteka.kz',
}
